<div class="tag">{{tag | lowercase | ucfirst}}</div>
